import {
  AudienceFilter,
  Topic,
  TopicMessages,
  defineTopic,
} from 'magpie-lib/models';
import { ncRemoteOperations } from '../messages';

export const APPLICATION_COMMS_TOPIC_NAME =
  '@@navigation-components/application-comms';

export const navComponentCommsTopicDef = defineTopic({
  name: `${APPLICATION_COMMS_TOPIC_NAME}`,
  messages: [...Object.values(ncRemoteOperations)] as const,
  enableRuntimeValidation: false,
  enableDeliveryConfirmation: false,
  audience: AudienceFilter.builder().build(),
});

export type NavComponentCommsTopic = Topic<typeof navComponentCommsTopicDef>;
export type NavComponentsCommsMessage = TopicMessages<
  typeof navComponentCommsTopicDef
>;
